import Store from '@/main/store';

import { sendInteractEventFunctionParam } from '@/app/features/InteractEventTracker/module/actions';

export const sendInteractEvent = ({ action, attributes, options }: sendInteractEventFunctionParam): Promise<any> => {
  return Store.dispatch('App/InteractEventTracker/sendInteractEvent', { action, attributes, options }, { root: true });
};
